module.exports = __webpack_public_path__ + "img/5.60ff1736.png";